import {ApiError} from './redux-api-v2';
import {
  RequestOptions,
  ApiPostOptions,
  ApiOptions,
  OtherOptions,
  baseNoStore,
} from './redux-api';

import {emptyObject} from 'src/utils';

// Functions to make http requests without dispatch and going through
// the index or redux stores.
export const baseRequest = async (
  path: string,
  options: RequestInit,
  otherOptions?: OtherOptions,
): Promise<any> => {
  const allOtherOptions: OtherOptions = {
    ...otherOptions,
  };

  // @ts-expect-error - TS2339 - Property 'csrfToken' does not exist on type 'Window & typeof globalThis'.
  if (window && window.csrfToken) {
    // @ts-expect-error - TS2339 - Property 'csrfToken' does not exist on type 'Window & typeof globalThis'.
    allOtherOptions.csrfToken = String(window.csrfToken);
  }

  const response = await baseNoStore(path, options, allOtherOptions);

  const text = await response.text();

  let json;
  if (response.headers.get('Content-Type') === 'application/json') {
    try {
      json = JSON.parse(text);
    } catch (error: any) {
      // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'path' does not exist in type 'RequestInit'.
      throw new ApiError({path, ...options}, response, text, error);
    }
  } else {
    json = text;
  }

  if (!response.ok) {
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'path' does not exist in type 'RequestInit'.
    throw new ApiError({path, ...options}, response, json);
  }

  return json;
};

export const get = (
  path: string,
  query?: Record<any, any>,
  options: ApiOptions = emptyObject,
): Promise<any> =>
  baseRequest(path, {
    method: 'GET',
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'query' does not exist in type 'RequestInit'.
    query,
    options,
  });

export const post = (
  path: string,
  data?: Record<any, any>,
  query?: Record<any, any>,
  options?: ApiPostOptions,
): Promise<any> =>
  baseRequest(path, {
    method: 'POST',
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'data' does not exist in type 'RequestInit'.
    data,
    query,
    options,
  });

export const put = (
  path: string,
  data?: Record<any, any>,
  query?: Record<any, any>,
  options: ApiPostOptions = emptyObject,
): Promise<any> =>
  baseRequest(path, {
    method: 'PUT',
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'data' does not exist in type 'RequestInit'.
    data,
    query,
    options,
  });

export const del = (
  path: string,
  data?: Record<any, any>,
  options?: ApiOptions,
): Promise<any> =>
  baseRequest(path, {
    method: 'DELETE',
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'data' does not exist in type 'RequestInit'.
    data,
    options,
  });
